// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageCollage_container__lEGGA","image1":"ImageCollage_image1__axKvA","singleImage":"ImageCollage_singleImage__mwBWl","imageStack":"ImageCollage_imageStack__szZC_"};